import { inject } from "vue";
export function useTime() {
  var $moment = inject("momentTime");
  function typeToStartEnd(type) {
    var start_time = ""
    var end_time = ""
    switch (type) {
      case "1":
        end_time = $moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD");
        start_time = $moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD");
        break;
      case "7":
        end_time = $moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD");
        start_time = $moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD");
        break;
      case "30":
        end_time = $moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD");
        start_time = $moment()
          .subtract(30, "d")
          .format("YYYY-MM-DD");
        break;
      case "month":
        end_time = $moment()
          .endOf("month")
          .format("YYYY-MM-DD");
        start_time = $moment().startOf("month").format("YYYY-MM-DD");
        break;
      case "week":
        end_time = $moment()
          .startOf("week")
          .format("YYYY-MM-DD");
        start_time = $moment().endOf("week").format("YYYY-MM-DD");
        break;
      case "quarterly":
        end_time = $moment()
          .startOf("year")
          .format("YYYY-MM-DD");
        start_time = $moment().endOf("year").format("YYYY-MM-DD");
        break;
      case "year":
        end_time = $moment()
          .endOf("year")
          .format("YYYY-MM-DD");
        start_time = $moment().startOf("year").format("YYYY-MM-DD");

        break;


    }
    return {
      start_time,
      end_time
    }
  }
  function dateTargets(type) {
    var formt = type == 'month' ? "YYYY-MM" : (type == 'year' ? "YYYY" : "YYYY-MM-DD")
    return $moment().endOf(type).format(formt);
  }

  function dataBefore(){
    return $moment().subtract(1, 'days').format('YYYY-MM-DD');
  }
  return {
    typeToStartEnd,
    dateTargets,
    dataBefore
  }
}
